<script>
export default {
    name: 'ButtonToggle',

    props: {
        value: null,
        data: {
            type: Array,
            default: () => [
                {
                    value: false,
                    label: 'State 1',
                },
                {
                    value: true,
                    label: 'State 2',
                },
            ],
        },
    },

    computed: {
        stateFalse() {
            return this.data ? this.data[0] : {}
        },
        stateTrue() {
            return this.data ? this.data[1] : {}
        },
        state() {
            return this.value === this.stateTrue.value
        },
    },

    methods: {
        setState(state, value) {
            this.$emit('input', value)
        },
    },
}
</script>

<template lang="pug">
    .btn-toggle
        button.btn.btn-secondary.btn-pill.state(@click="setState(false, stateFalse.value)" :class="{'state-on': !state}") {{stateFalse.label}}
            span {{stateFalse.label}}
        button.btn.btn-secondary.btn-pill.state(@click="setState(true, stateTrue.value)" :class="{'state-on': state}")  {{stateTrue.label}}
            span {{stateTrue.label}}
        .btn.btn-dark.btn-pill.handler.active(:class="{'state-on': state}")
</template>
